<template>
  <div class="body-wrapper">
    <HomeModal />
    <WaBtn />
    <Headernav />
    <div class="header-banner-wrapper">
      <div class="container pt-12 lg:pt-0 lg:flex items-center">
        <div class="w-full">
          <div class="banner-title text-white text-center">Efficient. Accurate. Fast.</div>
          <div class="banner-text text-xl md:text-3xl lg:font-bold text-white mb-6 lg:mb-12 text-center">Free On-Site Consultation</div>
          <div class="btn-width m-auto"><a href="#contact-area" class="m-auto"><div class="orange-btn">Enquire Now</div></a></div>
        </div>
      </div>
    </div>
    <div class="w-full bg-whiter">
      <div class="w-full section bg-orange-100">
        <div class="container pb-8">
          <div class="w-full border-b-2 border-orange-500 pb-2">
            <div class="section-title text-gray-800">
              <span class="section-title-span">About</span> Alpha Design & Construction
            </div>
          </div>
        </div>
        <div class="container lg:flex lg:items-center">
          <div class="w-full lg:w-6/12 pb-8 lg:pb-0">
            <img class="m-auto lg:m-0 block md:hidden lg:block" src="/images/profile-img.jpg" alt="profile image">
            <img class="m-auto lg:m-0 hidden md:block lg:hidden" src="/images/profile-img-tab.jpg" alt="profile image">
          </div>
          <div class="w-full lg:w-6/12">
           <div class="text-common text-gray-800 text-justify">
              Established since November 2011, Alpha Design & Construction has been actively involved in <b>reinstatement service, architectural design, building restoration and renovation</b> for private as well as public listed companies. We have <b>years of experience and expertise to handle all your remodeling needs</b>.
              <br><br>
              As one of the leading & reliable interior design and renovation contractor in Malaysia, we are your <b>guarantee of quality</b>. We strive to provide the highest quality customer service in the industry and we have a reputation that we are proud of. In our profession of concern, we are dedicated to <b>delivering best-value services</b> based on proven construction projects. Our client includes local and international organizations.
              <br><br>
              We are able to <b>handle high rise maintenance, reinstatement services, building design, renovation services, restoration, texture coating and cladding</b>. So whether you are simply looking for a dedicated building restoration, reinstatement projects or building renovation, feel free to contact us for an obligation-free discussion. We look forward to working with you!
           </div>
          </div>
        </div>
      </div>
      <div class="w-full section common-bg">
        <div class="container">
          <div class="w-full border-b-2 border-orange-500 pb-2 mb-8">
            <div class="section-title text-gray-800">
              <span class="section-title-span">Our</span> Services
            </div>
          </div>
          
          <!-- New Our Services -->
          <div class="pt-8 md:flex md:flex-wrap lg:items-center">
          <div
            v-for="(item, i) in whatwedo"
            :key="i"
            class="pb-6 md:px-1 md:w-1/2 lg:w-1/4"
          >
            <h1
              class="pb-4 text-xl font-bold text-center text-tg-orange"
            >
              {{ item.alt }}
            </h1>
            <div class="relative custom">
              <img :src="item.image" :alt="item.alt" class="rounded-lg" />
                <div class="overlay">
                  <h1 class="p-5 text-sm text-gray-600 bg-gray-100 text">
                  {{ item.content }}</h1>
                </div>
            </div>
          </div>
          <!-- button -->
          <a href="https://wa.me/60102721682" id="wa-btn-middle" class="block mx-auto pt-6">
            <div class="w-48 mx-auto orange-btn rounded-md">
              <h1 class="py-1 text-base font-bold text-center text-white uppercase">
                Whatsapp Us 
              </h1>
            </div>
          </a>
        </div>
          <!-- end New Our Services -->

        </div>
      </div>
      <!-- old why choose us -->
      <!-- <div class="w-full common-bg">
        <div class="container pb-10">
          <div class="w-full border-b-2 border-orange-500 pb-2">
            <div class="section-title text-gray-800">
              <span class="section-title-span">Your</span> Right Choice
            </div>
          </div>
        </div>
        <div class="container md:flex">
          <div class="w-full md:w-4/12 lg:w-3/12 text-center pb-5 lg:pb-0">
            <img class="m-auto pb-4" src="/images/right-choice01.png" alt="Quality Assurance">
            <span class="font-bold text-lg">Quality Assurance</span>
          </div>
          <div class="w-full md:w-4/12 lg:w-3/12 text-center pb-5 lg:pb-0">
            <img class="m-auto pb-4" src="/images/right-choice02.png" alt="99% Customer Satisfactions">
            <span class="font-bold text-lg">99% Customer Satisfactions</span>
          </div>
          <div class="w-full md:w-4/12 lg:w-3/12 text-center pb-5 lg:pb-0">
            <img class="m-auto pb-4" src="/images/right-choice03.png" alt="Reliable">
            <span class="font-bold text-lg">Reliable</span>
          </div>
          <div class="w-full md:w-4/12 lg:w-3/12 text-center pb-5 lg:pb-0">
            <img class="m-auto pb-4" src="/images/right-choice04.png" alt="Fast Respond Time">
            <span class="font-bold text-lg">Fast Respond Time</span>
          </div>
        </div>
      </div> -->

      <!-- why choose us -->
      <div
      class="py-10 bg-center bg-no-repeat bg-cover"
      style="background-image: url('/images/bg-choose.jpg')"
    >
      <div class="container">
        <h1 class="pb-3 text-2xl font-bold text-center text-white">
          Your Right Choice
        </h1>
        <div class="w-10 h-1 mx-auto bg-white"></div>
        <div class="flex flex-wrap pt-5 md:justify-center">
          <div
            v-for="(item, i) in choose_us"
            :key="i"
            class="w-1/2 p-1 md:w-1/3 lg:w-1/6"
          >
            <div class="p-4 rounded-lg bg-tg-blue">
              <img :src="item.image" :alt="item.alt" class="w-24 mx-auto" />
              <h1
                class="pt-4 text-base font-semibold leading-tight text-center text-white lg:justify-center lg:flex lg:items-center h-14"
              >
                {{ item.alt }}
              </h1>
            </div>
          </div>
        </div>
      </div>
      </div>
      <!-- end why choose us -->

      <!-- Our Projects -->
      <div class="w-full section">
        <div class="container">
          <div class="w-full border-b-2 border-orange-500 pb-2 mb-8">
            <div class="section-title text-gray-800">
              <span class="section-title-span">Our</span> Projects
            </div>
          </div>
          <div class="pt-10">
          <carousel
            :autoplay="true"
            :loop="true"
            :dots="true"
            :responsive="{
              0: { items: 1, nav: false },
              600: { items: 3, nav: false },
              1000: { items: 4, nav: false },
            }"
          >
            <!--carousel area-->
            <div v-for="(item, i) in works" :key="i" class="">
              <div class="px-1">
                <img :src="item.image" :alt="item.alt" class="shadow-md" />
              </div>
            </div>
          </carousel>
          <!-- button -->
          <a href="https://wa.me/60102721682" id="wa-btn-middle" class="block mx-auto pt-6">
            <div class="w-48 mx-auto orange-btn rounded-md">
              <h1 class="py-1 text-base font-bold text-center text-white uppercase">
                Whatsapp Us 
              </h1>
            </div>
          </a>
        </div>
        </div>
      </div>
      <!-- end Our Projects -->

      <!-- Our Clientele  -->
      <div class="w-full common-bg" style="padding-bottom:60px">
        <div class="container">
          <div class="w-full border-b-2 border-orange-500 pb-2 mb-8">
            <div class="section-title text-gray-800">
              
              <span class="section-title-span">Our</span> Clienteles
            </div>
          </div>

          <!-- new Clientele -->
          <div class="pt-10">
          <carousel
            :autoplay="true"
            :loop="true"
            :dots="true"
            :responsive="{
              0: { items: 1, nav: false },
              600: { items: 4, nav: false },
              1000: { items: 5, nav: false },
            }"
          >
            <!--carousel area-->
            <div v-for="(item, i) in client" :key="i" class="px-1">
              <div class="w-full mx-auto md:w-full">
                <img :src="'/images/clientele/'+ item + '.jpg'" :alt="item.alt" class="" />
              </div>
            </div>
          </carousel>
        </div>
          <!-- end clientele -->
        </div>
      </div>
      <!-- end Our Clientele -->

      <!-- Our certificate -->
      <div class="w-full py-16 bg-color">
        <div class="w-full border-b-2 border-orange-500 pb-2 mb-8">
            <div class="section-title text-center text-white">
              <span>Our</span> Certificates
            </div>
            <p class="text-base font-semibold pt-2 text-center text-white">We are a CIDB G7 accredited contractor</p>
          </div>

          <div class="px-2 md:flex md:flex-wrap">
            <div v-for="image in certificate" :key="image" class="pb-1 md:p-1 xl:w-1/5 lg:w-1/3 md:w-1/2 lg:mx-0 mx-auto">
              <img :src="image" alt="" class="">
            </div>
          </div>
      </div>
      <!-- end our certificate -->

      <div id="contact-area" class="w-full section common-bg-dark">
        <div class="container">
          <div class="w-full pb-6">
            <div class="section-title text-center text-gray-800">
              <span class="section-title-span">Send</span> Us an Enquiry
            </div>
            <div class="w-full md:text-lg text-center">
              Fill out the form below and we'll get back to you as soon as possible
            </div>
          </div>
          <div class="w-full">
            <!-- feedback.activamedia.com.sg script begins here -->
            <iframe allowTransparency="true" style="min-height:550px; height:inherit; overflow:auto;" width="100%" id="contactform123" name="contactform123" marginwidth="0" marginheight="0" frameborder="0" src="https://feedback.activamedia.com.sg/my-contact-form-5531053.html">
              <p>Your browser does not support iframes. The contact form cannot be displayed. Please use another contact method (phone, fax etc)</p>
            </iframe>
            <!-- feedback.activamedia.com.sg script ends here -->
          </div>
        </div>
      </div>
    </div>
    <div class="w-full flex justify-center">
      <img src="/images/contact-arrow.png" alt="contact arrow">
    </div>
    <div class="w-full section common-bg">
      <div class="container md:flex mb-8 lg:mb-12">
        <div class="w-full md:w-4/12 text-center pb-5 lg:pb-0">
          <img class="m-auto pb-4" src="/images/icon-tel.png" alt="icon tel">
          <a href="tel:010-2721682" target="_blank" class="text-lg hover:text-orange-500">010 - 272 1682</a>
        </div>
        <div class="w-full md:w-4/12 text-center pb-5 lg:pb-0">
          <img class="m-auto pb-4" src="/images/icon-map.png" alt="icon maps">
          <span class="text-lg">E-2-16, Plaza Arkadia, Jalan Intisari Perdana 3, Desa Park City, 52200 Kuala Lumpur.</span>
        </div>
        <div class="w-full md:w-4/12 text-center pb-5 lg:pb-0">
          <img class="m-auto pb-4" src="/images/icon-mail.png" alt="icon mail">
          <a href="mailto:enquiry@alphadesign.com.my" target="_blank" class="text-lg hover:text-orange-500">enquiry@alphadesign.com.my</a>
        </div>
      </div>
      <div class="container">
        <div class="w-full">
          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7967.240711864092!2d101.636757!3d3.194051!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x45cfdda36fe068d4!2sAlpha%20Design%20%26%20Construction%20Sdn%20Bhd!5e0!3m2!1sen!2smy!4v1593585177765!5m2!1sen!2smy" width="100%" height="380" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
        </div>
      </div>
    </div>
    <div class="w-full bg-black text-white text-center pt-6 pb-8">
      <p>Website maintained by <a href="https://www.activamedia.com.sg/" target="_blank" class="hover:text-orange-500">Activa Media</a>. All rights reserved.</p>
    </div>
  </div>
</template>
<script>
import Headernav from '@/components/Headernav.vue'
import WaBtn from "@/components/WaBtn.vue"
import carousel from "vue-owl-carousel";
import vueSmoothScroll from 'vue-smooth-scroll'
import HomeModal from "@/components/HomeModal.vue"

export default {
  components: {
    Headernav,
    vueSmoothScroll,
    WaBtn,
    carousel,
    HomeModal
  },
  data(){
    return {
      certificate:[
        '/images/certificate-1.jpg',
        '/images/certificate-2.jpg',
        '/images/certificate-3.jpg',
        '/images/certificate-4.jpg',
        '/images/certificate-5.jpg',
      ],
      works: [
        { image: "/images/work-1.jpg", alt: "" },
        { image: "/images/work-2.jpg", alt: "" },
        { image: "/images/work-3.jpg", alt: "" },
        { image: "/images/work-4.jpg", alt: "" },
        { image: "/images/work-5.jpg", alt: "" },
        { image: "/images/work-6.jpg", alt: "" },
        { image: "/images/work-7.jpg", alt: "" },
        { image: "/images/work-8.jpg", alt: "" },
        { image: "/images/work-9.jpg", alt: "" },
        { image: "/images/work-10.jpg", alt: "" },
        { image: "/images/work-11.jpg", alt: "" },
        { image: "/images/work-12.jpg", alt: "" },
        { image: "/images/work-13.jpg", alt: "" },
        { image: "/images/work-14.jpg", alt: "" },
        { image: "/images/work-15.jpg", alt: "" },
        { image: "/images/work-16.jpg", alt: "" },
        { image: "/images/work-17.jpg", alt: "" },
        { image: "/images/work-18.jpg", alt: "" },
        { image: "/images/work-19.jpg", alt: "" },
        { image: "/images/work-20.jpg", alt: "" },
      ],
      client: [
        'logo-1',
        'logo-2',
        'logo-3',
        'logo-4',
        'logo-5',
        'logo-6',
        'logo-7',
        'logo-8',
        'logo-9',
        'logo-10',
        'logo-11',
        'logo-12',
        'logo-13',
        'logo-14',
        'logo-15',
        'logo-16',
        'logo-17',
        'logo-18',
        'logo-19',
      ],
      choose_us: [
        { image: "/images/icon-1.png", alt: "Quality Assurance" },
        { image: "/images/icon-2.png", alt: "99% Customer Satisfactions" },
        { image: "/images/icon-3.png", alt: "Reliable" },
        { image: "/images/icon-4.png", alt: "Fast Respond Time" },
      ],
      whatwedo: [
        {
          image: "/images/product-1.jpg",
          alt: "Interior Designs",
          content:
            "Your goals and satisfaction is our first priority. We aim to provide professional services and create a suitable style office space for your premises, no matter generic retro designs, commercial or corporate style.",
        },
        {
          image: "/images/product-2.jpg",
          alt: "Renovation Services",
          content:
            "The only limit for us is the sky! We are well known for our renovation services in Malaysia, and we have a well-established position in the construction industry.",
        },
        {
          image: "/images/product-3.jpg",
          alt: "Reinstatement Services",
          content:
            "Most tenants, especially first-time tenants, are not aware that moving out of a premise requires certain obligations (tenancy reinstatement) to the landlord. Our cost-effective office reinstatement service​ and restoration​ ​service​ can help you get the property ready and hassle-free handover back to the landlord.",
        },
        {
          image: "/images/product-4.jpg",
          alt: "Office Equipment & Supplies",
          content:
            "We source equipments from some of the top brand distributor. We are focusing more on our customers' success by a quick respond act with a sense of urgency, deliver on our promises and treat each other with respects.",
        },
      ],
    }
  },
  mounted() {
    window.onload = (event) => {
      document.querySelector("#home-modal").classList.add("active");
    };
  },
}
</script>
<style>
.overlay {
  top:0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.5s ease;
}

.custom:hover .overlay {
  opacity: 1;
}

.text {
  /* font-size: 20px; */
  width: 300px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
}
</style>
